// ABOUTME: Toggle button group component for grouped related buttons
// ABOUTME: Applies proper border-radius styles to first/middle/last buttons

import * as React from "react"
import { cn } from "@shared/lib/utils"

export interface CButtonToggleGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

export const CButtonToggleGroup: React.FC<CButtonToggleGroupProps> = ({ className, children, ...props }) => {
  const childArray = React.Children.toArray(children).filter(Boolean)
  const childCount = childArray.length

  const styledChildren = React.Children.map(childArray, (child, index) => {
    if (!React.isValidElement(child)) return child

    const isFirst = index === 0
    const isLast = index === childCount - 1
    const isMiddle = !isFirst && !isLast

    const groupStyles = cn(
      // Remove rounded corners based on position
      isFirst && "!rounded-r-none",
      isLast && "!rounded-l-none",
      isMiddle && "!rounded-none",
      // Remove border overlap
      !isFirst && "-ml-px",
      // Focus state should show above siblings
      "focus:z-10",
    )

    const childWithProps = child as React.ReactElement<{ className?: string }>
    return React.cloneElement(childWithProps, {
      className: cn(childWithProps.props.className, groupStyles),
    })
  })

  return (
    <div
      className={cn("inline-flex", className)}
      role="group"
      {...props}
    >
      {styledChildren}
    </div>
  )
}
